import './style.css';
import ClearIcon from '@mui/icons-material/Clear';

export default function ImagePicker({
  pickedImage,
  setImage,
  containerClass = '',
  placeholder,
  hideCancel = false
}) {
  return (
    <div className={'picker'}>
      <div className={'controls'}>
        <div className={`preview ${containerClass}`}>
          {pickedImage && (
            <>
              {!hideCancel && (
                <ClearIcon
                  sx={{
                    position: 'absolute',
                    top: '5px',
                    color: 'red',
                    right: '5px',
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    setImage(null);
                  }}
                />
              )}
              <img src={pickedImage} alt="something" fill />
            </>
          )}
          {!pickedImage &&
            (placeholder ? placeholder : <p>No image picked yet</p>)}
        </div>
      </div>
    </div>
  );
}
